export const vacanciesData = [
	'Укажите  свой город',
	'Выберите подходящую вакансию',
	'Заполните информацию о себе',
	'Пройдите короткое онлайн‑обучение'
];
